export default __webpack_public_path__ + "static/media/icon_chart.52f1b7f2.svg";